import { values } from 'bundles/apex/deals/config';

export const orderedColumns = [
  values.displayName,
  values.id,
  values.dealTypeLabel,
  values.stageLabel,
  values.location,
  values.propertyTypeLabel,
  values.brokers,
  values.transactionValue,
  values.grossCommissionIncome,
  values.openTasks,
  values.nextCriticalDate,
  values.voucherAssociation,
];
